import { render } from "./LoderSendComponent.vue?vue&type=template&id=d6e79cda&scoped=true"
import script from "./LoderSendComponent.vue?vue&type=script&lang=js"
export * from "./LoderSendComponent.vue?vue&type=script&lang=js"

import "./LoderSendComponent.vue?vue&type=style&index=0&id=d6e79cda&scoped=true&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6e79cda"]])

export default __exports__